import { useCallback, useRef, useState } from "react";
import * as _ from "lodash";

type IsLoadedFunc = () => boolean;


export interface UseLoaderVal {
    isLoaded: boolean;
    checkIsLoaded: IsLoadedFunc;
}

export default function useLoader(componentName: string, isLoadedCheck?: IsLoadedFunc): UseLoaderVal {

    const isLoaded = useRef(false);

    const checkIsLoaded = useCallback(() => {
        const result = isLoadedCheck();
    
        if (result && !isLoaded.current) {
            isLoaded.current = result;
        }
        
        return result;
    }, [isLoadedCheck]);

    return {
        isLoaded: isLoaded.current,
        checkIsLoaded
    };
}
